import { renderErrorPage } from "../shared/error-page-renderer";

let container: HTMLElement | null = null;

export function bootstrap() {
  return Promise.resolve();
}

export function mount() {
  container = document.getElementById("single-spa-application:not-found");

  if (!container) {
    container = document.createElement("div");
    container.id = "single-spa-application:not-found";
    document.body.appendChild(container);
  }

  renderErrorPage(container, {
    title: "Page not found",
    message: `
      <p>The page you're looking for doesn't exist, or the link may be broken.</p>
      <p>If you believe this is an error, please contact your administrator.</p>
    `,
    iconSvg: `
      <svg class="not-found-icon-svg" width="84" height="94" viewBox="0 0 94 104" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M85.56 0H7.94C3.55486 0 0 3.55486 0 7.94V96.06C0 100.445 3.55486 104 7.94 104H85.56C89.9451 104 93.5 100.445 93.5 96.06V7.94C93.5 3.55486 89.9451 0 85.56 0Z" fill="white"/>
        <path d="M75.01 11.42H29.88C27.7648 11.42 26.05 13.1325 26.05 15.245C26.05 17.3575 27.7648 19.07 29.88 19.07H75.01C77.1253 19.07 78.84 17.3575 78.84 15.245C78.84 13.1325 77.1253 11.42 75.01 11.42Z" fill="#8D8D8D"/>
        <path d="M14.16 20.49C16.8275 20.49 18.99 18.3275 18.99 15.66C18.99 12.9925 16.8275 10.83 14.16 10.83C11.4925 10.83 9.33 12.9925 9.33 15.66C9.33 18.3275 11.4925 20.49 14.16 20.49Z" fill="#8D8D8D"/>
        <path d="M65.79 25.75H29.88C27.7648 25.75 26.05 27.4625 26.05 29.575C26.05 31.6875 27.7648 33.4 29.88 33.4H65.79C67.9053 33.4 69.62 31.6875 69.62 29.575C69.62 27.4625 67.9053 25.75 65.79 25.75Z" fill="#8D8D8D"/>
        <path d="M14.16 34.83C16.8275 34.83 18.99 32.6675 18.99 30C18.99 27.3325 16.8275 25.17 14.16 25.17C11.4925 25.17 9.33 27.3325 9.33 30C9.33 32.6675 11.4925 34.83 14.16 34.83Z" fill="#8D8D8D"/>
        <path d="M69.18 40.08H29.88C27.7648 40.08 26.05 41.7925 26.05 43.905C26.05 46.0175 27.7648 47.73 29.88 47.73H69.18C71.2952 47.73 73.01 46.0175 73.01 43.905C73.01 41.7925 71.2952 40.08 69.18 40.08Z" fill="#8D8D8D"/>
        <path d="M14.16 49.16C16.8275 49.16 18.99 46.9975 18.99 44.33C18.99 41.6625 16.8275 39.5 14.16 39.5C11.4925 39.5 9.33 41.6625 9.33 44.33C9.33 46.9975 11.4925 49.16 14.16 49.16Z" fill="#8D8D8D"/>
        <path d="M54.62 54.42H29.88C27.7648 54.42 26.05 56.1325 26.05 58.245C26.05 60.3575 27.7648 62.07 29.88 62.07H54.62C56.7353 62.07 58.45 60.3575 58.45 58.245C58.45 56.1325 56.7353 54.42 54.62 54.42Z" fill="#8D8D8D"/>
        <path d="M14.16 63.49C16.8275 63.49 18.99 61.3275 18.99 58.66C18.99 55.9925 16.8275 53.83 14.16 53.83C11.4925 53.83 9.33 55.9925 9.33 58.66C9.33 61.3275 11.4925 63.49 14.16 63.49Z" fill="#8D8D8D"/>
        <path d="M75.01 68.75H29.88C27.7648 68.75 26.05 70.4625 26.05 72.575C26.05 74.6875 27.7648 76.4 29.88 76.4H75.01C77.1253 76.4 78.84 74.6875 78.84 72.575C78.84 70.4625 77.1253 68.75 75.01 68.75Z" fill="#8D8D8D"/>
        <path d="M14.16 77.83C16.8275 77.83 18.99 75.6675 18.99 73C18.99 70.3325 16.8275 68.17 14.16 68.17C11.4925 68.17 9.33 70.3325 9.33 73C9.33 75.6675 11.4925 77.83 14.16 77.83Z" fill="#8D8D8D"/>
        <path d="M65.08 83.08H29.88C27.7648 83.08 26.05 84.7925 26.05 86.905C26.05 89.0175 27.7648 90.73 29.88 90.73H65.08C67.1953 90.73 68.91 89.0175 68.91 86.905C68.91 84.7925 67.1953 83.08 65.08 83.08Z" fill="#8D8D8D"/>
        <path d="M14.16 92.16C16.8275 92.16 18.99 89.9975 18.99 87.33C18.99 84.6625 16.8275 82.5 14.16 82.5C11.4925 82.5 9.33 84.6625 9.33 87.33C9.33 89.9975 11.4925 92.16 14.16 92.16Z" fill="#8D8D8D"/>
      </svg>
    `,
  });

  return Promise.resolve();
}

export function unmount() {
  if (container) {
    container.remove();
    container = null;
  }
  return Promise.resolve();
}
